import React, {useEffect} from "react";
import LazyLoad from "react-lazyload";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import DownloadsCategory from "./DownloadsCategory";
import {i18n} from "../../helpers/localisation-helpers";

const Downloads = () => {
    const {  productData } = useTypedSelector((state) => state.product);
    
    if(productData == undefined || 
        productData.ProductFiles == undefined || 
        productData.ProductFiles.length == 0) {

        return null;
    }

    return (
        <div className="downloads">
            <div className="onepcssgrid-1300 onepcssblockgrid">
                <div className="onerow">
                    <div className="col12 last content">
                        <h2><a id="downloads">{i18n("Resource.Downloads", productData.PageLocalisations)}</a></h2>
                        
                        {productData.ProductFiles.map((dlCat, index) => {
                            return (
                                <DownloadsCategory key={index} category={dlCat.CategoryName} />
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Downloads;